/**
 * API de dominio del módulo sync — tipos y funciones PURAS.
 *
 * Cero dependencias de otros módulos de negocio (catalog, sales, pos, expenses,
 * customers, inventory, etc.). Solo importa de `./core/syncTypes` o `../../shared/**`.
 *
 * Importar desde acá para evitar require cycles: este archivo no dispara la
 * evaluación de módulos que cierran ciclos contra sync/public-api.
 */

// --- OperationId (puros: sin imports) ---
export { buildCatalogSyncOperationId } from './core/catalogSyncOperationId';
